<template>
  <div>
    <Toolbar
      :handle-submit="onSendProdFileForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-qrcode</v-icon>{{$t('profile.material.productlot')}}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <MaterialProductLotForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import MaterialProductLotForm from '../../components/materialproductlot/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import FileMixin from '../../mixins/FileMixin';

const servicePrefix = 'MaterialProductLot';

export default {
  name: 'MaterialProductLotUpdate',
  servicePrefix,
  mixins: [UpdateMixin,FileMixin],
  components: {
    Loading,
    Toolbar,
    MaterialProductLotForm
  },

  computed: {
    ...mapFields('materialproductlot', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('materialproductlot', ['find'])

  },

  methods: {
    ...mapActions('materialproductlot', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    onSendProdFileForm() {
      this.onSendForm();
      this.inputfile = this.item.file;
    }
  }
};
</script>
